/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ConcreteRequest } from 'relay-runtime';
type AggregatesListingsSEOLinks_popularSearches$ref = any;
export type LangInput = "de" | "en" | "es" | "fr" | "it";
export type AggregatesListingsCustomPageSearchedByPlaceQueryVariables = {|
  placeSlug: string,
  customPageSlug: string,
  offerType: string,
  lang: LangInput,
|};
export type AggregatesListingsCustomPageSearchedByPlaceQueryResponse = {|
  +aggregatorCustomPagesByPlace: $ReadOnlyArray<{|
    +slug: string,
    +$fragmentRefs: AggregatesListingsSEOLinks_popularSearches$ref,
  |}>
|};
export type AggregatesListingsCustomPageSearchedByPlaceQuery = {|
  variables: AggregatesListingsCustomPageSearchedByPlaceQueryVariables,
  response: AggregatesListingsCustomPageSearchedByPlaceQueryResponse,
|};
*/


/*
query AggregatesListingsCustomPageSearchedByPlaceQuery(
  $placeSlug: String!
  $customPageSlug: String!
  $offerType: String!
  $lang: LangInput!
) {
  aggregatorCustomPagesByPlace(placeSlug: $placeSlug, offerType: $offerType, customPageSlug: $customPageSlug, language: $lang) {
    ...AggregatesListingsSEOLinks_popularSearches
    slug
    id
  }
}

fragment AggregatesListingsSEOLinks_popularSearches on AggregatorCustomPage {
  h1
  slug
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "customPageSlug"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lang"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offerType"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "placeSlug"
},
v4 = [
  {
    "kind": "Variable",
    "name": "customPageSlug",
    "variableName": "customPageSlug"
  },
  {
    "kind": "Variable",
    "name": "language",
    "variableName": "lang"
  },
  {
    "kind": "Variable",
    "name": "offerType",
    "variableName": "offerType"
  },
  {
    "kind": "Variable",
    "name": "placeSlug",
    "variableName": "placeSlug"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AggregatesListingsCustomPageSearchedByPlaceQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "AggregatorCustomPage",
        "kind": "LinkedField",
        "name": "aggregatorCustomPagesByPlace",
        "plural": true,
        "selections": [
          (v5/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AggregatesListingsSEOLinks_popularSearches"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "AggregatesListingsCustomPageSearchedByPlaceQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "AggregatorCustomPage",
        "kind": "LinkedField",
        "name": "aggregatorCustomPagesByPlace",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "h1",
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2ea49b44ac214b14cbe4ad5854680577",
    "id": null,
    "metadata": {},
    "name": "AggregatesListingsCustomPageSearchedByPlaceQuery",
    "operationKind": "query",
    "text": "query AggregatesListingsCustomPageSearchedByPlaceQuery(\n  $placeSlug: String!\n  $customPageSlug: String!\n  $offerType: String!\n  $lang: LangInput!\n) {\n  aggregatorCustomPagesByPlace(placeSlug: $placeSlug, offerType: $offerType, customPageSlug: $customPageSlug, language: $lang) {\n    ...AggregatesListingsSEOLinks_popularSearches\n    slug\n    id\n  }\n}\n\nfragment AggregatesListingsSEOLinks_popularSearches on AggregatorCustomPage {\n  h1\n  slug\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f5a0332e5296623c5f77f4ec12ac9a3f';

export default node;
